<template>
  <chart
    :width="width"
    :height="height"
    :chart-data="chartData"
    :options="options"
  />
</template>
<script>
import moment from 'moment'
import Chart from '@/components/charts/Chart'

export default {
  name: 'AmcArpuChart',
  components: {
    Chart
  },
  props: {
    width: {
      type: Number,
      default: undefined
    },
    height: {
      type: Number,
      default: undefined
    },
    report: {
      type: Array,
      default: null
    },
    precision: { // 小数点第何位まで表示するか決める
      type: Number,
      default: 0
    },
    labelField: {
      type: String,
      default: 'eventMonth'
    },
    startDay: {
      type: String,
      default: null
    },
    endDay: {
      type: String,
      default: null
    }
  },
  computed: {
    chartData () {
      const start = moment(this.startDay)
      const end = moment(this.endDay)

      const target = moment(this.startDay);
      const range = end.diff(start, 'months') + 1
      let i = 0
      const datasets = []
      do {
        datasets.push(
          {
            type: 'bar',
            label: target.format("YYYY年MM月").toString(),
            data: this.report.map(item => item[target.format("YYYY-MM").toString()]),
            yAxisID: 'barChart'
          }
        )
        target.add(1, 'month')
        i++
      } while (i < range);
      datasets.push(
        {
          type: 'bar',
          label: '不明',
          data: this.report.map(item => item['unknown']),
          backgroundColor: '#E0E0E0',
          yAxisID: 'barChart'
        }
      )

      return {
        labels: this.report.map(item => item[this.labelField]),
        datasets: datasets
      }
    },
    options () {
      return {
        plugins: {
          legend: {
            display: true,
            reverse: false
          },
          tooltip: {
            mode: 'index',
            position: 'nearest',
            callbacks: {
              label (tooltipItem) {
                const label = tooltipItem.dataset.label
                const value = tooltipItem.formattedValue
                if (label.includes('率')) {
                  return `${label}: ${value}%`
                }
                return `${label}: \xA5${value}`
              }
            }
          }
        },
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true
          },
          barChart: {
            stacked: true,
            ticks: {
              callback (value) {
                return `\xA5${value.toLocaleString()}`
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
